import { extendTheme } from '@chakra-ui/react';

// MommaFuel color palette with improved contrast
const colors = {
  mamaFuel: {
    cream: '#FDF8F5', // Lighter cream background for better contrast
    taupe: '#D8CAB8', // Warm Taupe (accent 1)
    rose: '#D6A5A5', // Dusty Rose (accent 2)
    moss: {
      100: '#D9E4CC', // Lighter moss
      300: '#C8C8A8', // Lighter moss2
      500: '#B6C4A2', // Moss Green (accent 3)
      600: '#9CAF85', // Slightly darker moss
      700: '#5C7457', // Darker green for buttons
      800: '#485C45', // Even darker green for contrast
    },
    red: {
      700: '#DC3545', // Darker red for buttons
    },
    clay: '#C88F89', // Clay Pink (highlight)
    text: {
      primary: '#1A1A1A', // Near black for better contrast with backgrounds
      secondary: '#333333', // Dark gray
      light: '#666666', // Medium gray
    }
  }
};

// Component-specific theming
const components = {
  Heading: {
    baseStyle: {
      color: 'mamaFuel.text.primary',
      fontWeight: '600',
    },
  },
  Text: {
    baseStyle: {
      color: 'mamaFuel.text.primary',
    },
  },
  Button: {
    baseStyle: {
      _disabled: {
        // Override all hover effects when disabled
        _hover: {
          pointerEvents: 'none', // This is key - prevents hover entirely
        },
      },
    },
    variants: {
      primary: {
        bg: 'mamaFuel.moss.700',
        color: 'white',
        _hover: {
          transform: 'translateY(-2px)',
        },
      },
      red: {
        bg: 'mamaFuel.red.700',
        color: 'white',
        _hover: {
          transform: 'translateY(-2px)',
        },
      },
      outline: {
        borderColor: 'mamaFuel.moss.700',
        color: 'mamaFuel.moss.700',
        _hover: {
          transform: 'translateY(-2px)',
        },
      },
    },
    defaultProps: {
      variant: 'primary',
    },
  },
  Link: {
    baseStyle: {
      color: 'mamaFuel.moss.700',
      _hover: {
        textDecoration: 'none',
      },
    },
    variants: {
      nav: {
        px: '2',
        py: '1',
        rounded: 'md',
        color: 'mamaFuel.text.primary',
        _hover: { 
          textDecoration: 'none', 
          bg: 'mamaFuel.moss.500',
          color: 'mamaFuel.text.primary'
        },
      },
    },
  },
  Box: {
    variants: {
      card: {
        bg: 'mamaFuel.moss.500',
        borderRadius: 'lg',
        boxShadow: 'md',
      },
      feature: {
        bg: 'mamaFuel.moss.500',
        borderRadius: 'lg',
        boxShadow: 'md',
        height: '100%',
        transition: 'transform 0.3s',
        _hover: { transform: 'translateY(-5px)' },
      },
      section: {
        bg: 'mamaFuel.moss.500',
        borderRadius: 'lg',
        p: '8',
      }
    },
  },
  Popover: {
    baseStyle: {
      content: {
        bg: 'mamaFuel.cream',
        borderColor: 'mamaFuel.moss.500',
      },
    },
  },
  Input: {
    baseStyle: {
      field: {
        borderColor: 'mamaFuel.moss.500',
        _focus: {
          borderColor: 'mamaFuel.moss.700',
        },
      },
    },
  },
};

// Global style overrides
const styles = {
  global: {
    'html, body': {
      bg: 'mamaFuel.cream',
      color: 'mamaFuel.text.primary',
      maxWidth: '100%',
      overflowX: 'hidden',
      height: 'auto !important',
      minHeight: '100%',
      overflowY: 'auto',
    },
    '#root': {
      maxWidth: '100%',
      overflowX: 'hidden',
      height: 'auto !important',
      minHeight: '100%',
      overflowY: 'auto',
    },
    '.registry-view-container': {
      minHeight: 'auto !important',
      height: 'auto !important',
      overflowY: 'auto !important',
    },
  },
};

// Export the theme
const theme = extendTheme({ colors, components, styles });
export default theme; 